import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

function DistanceIcon(props) {
  return (
    <SvgIcon viewBox="0 0 26 25" {...props}>
      <g clipPath="url(#clip0_1443_31942)">
        <path
          d="M25.2357 9.66082C25.2357 6.93143 23.0152 4.71094 20.2858 4.71094C17.5564 4.71094 15.3359 6.93143 15.3359 9.66082C15.3359 10.4607 15.5268 11.2167 15.8651 11.8859L20.2858 21.0022L24.7072 11.8845C25.045 11.2155 25.2357 10.46 25.2357 9.66082ZM20.2858 12.4001C18.7754 12.4001 17.5465 11.1712 17.5465 9.66082C17.5465 8.15043 18.7754 6.92156 20.2858 6.92156C21.7962 6.92156 23.025 8.15043 23.025 9.66082C23.025 11.1712 21.7962 12.4001 20.2858 12.4001Z"
          fill="currentColor"
        />
        <line
          x1="2.33594"
          y1="23.5"
          x2="20.3359"
          y2="23.5"
          stroke="currentColor"
        />
        <circle cx="2.33594" cy="23.5" r="1.5" fill="currentColor" />
        <circle cx="20.3359" cy="23.5" r="1.5" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_1443_31942">
          <rect
            width="25"
            height="25"
            transform="translate(0.335938)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default DistanceIcon;
